import React from 'react';
import { useTranslation } from 'react-i18next';
import { TbChartCohort } from 'react-icons/tb';
import PageWrapper from '../../components/common/PageWrapper';
import SessionNameManager from '../../components/cohort/SessionNameManager';

const UploadSessionsSettingsScreen = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('Upload Session Settings')}
      subtitle={t('Configure how upload session names are generated and detected.')}
      icon={<TbChartCohort size={24} />}
      showCard
    >
      <SessionNameManager embedded />
    </PageWrapper>
  );
};

export default UploadSessionsSettingsScreen;
